import classNames from "classnames";
import React from "react";
import { FormattedMessage } from "react-intl";
import { Link } from "react-router-dom";

import { Text } from "soapbox/components/ui";
import emojify from "soapbox/features/emoji/emoji";
import { useSoapboxConfig, useOwnAccount, useTheme } from "soapbox/hooks";
import sourceCode from "soapbox/utils/code";

import manganeDark from "../../../../icons/mangane-dark.svg";
import mangane from "../../../../icons/mangane.svg";

interface IFooterLink {
  to: string;
  className?: string;
  onClick?: React.EventHandler<React.MouseEvent>;
}

const FooterLink: React.FC<IFooterLink> = ({
  children,
  className,
  ...rest
}): JSX.Element => {
  return (
    <div>
      <Link
        className={classNames(
          "text-gray-400 hover:text-gray-500 hover:underline",
          className,
        )}
        {...rest}
      >
        {children}
      </Link>
    </div>
  );
};

const LinkFooter: React.FC = (): JSX.Element => {
  const account = useOwnAccount();
  const soapboxConfig = useSoapboxConfig();

  const darkMode = useTheme() === "dark";

  return (
    <div className="space-y-2">
      <Text theme="muted" size="sm">
        {soapboxConfig.linkFooterMessage && (
          <span
            className="inline-block align-middle"
            dangerouslySetInnerHTML={{
              __html: emojify(soapboxConfig.linkFooterMessage),
            }}
          />
        )}
      </Text>
    </div>
  );
};

export default LinkFooter;
